import React from 'react';

import localStyles from './styles.module.scss'

const Loader = (props: any) => {
    return (
        <div className={localStyles.container} {...props}>
            <div className={localStyles.blockAnimate}>
                <img src="/client/src/assets/img/loader_arrow_blue.svg" alt=""/>
                <img src="/client/src/assets/img/loader_arrow_blue.svg" alt=""/>
                <img src="/client/src/assets/img/loader_arrow_red.svg" alt=""/>
                <img src="/client/src/assets/img/loader_arrow_blue.svg" alt=""/>
                <img src="/client/src/assets/img/loader_arrow_blue.svg" alt=""/>
                <img src="/client/src/assets/img/loader_arrow_red.svg" alt=""/>
            </div>
        </div>
    );
};

export default Loader;
